import { Navigate, useLocation } from 'react-router-dom';

import { useIsAuthenticated } from '@/lib/auth/hooks';
import { useAuthStore } from '@/lib/auth/store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  permission?: string;
}

export function ProtectedRoute({ children, permission }: ProtectedRouteProps) {
  const isAuth = useIsAuthenticated();
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const location = useLocation();

  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (permission && !hasPermission(permission)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
